module.exports = __webpack_public_path__ + "img/coin-007.47f8ba1d.svg";